$(document).ready(function() {
    var $_header = $('#header');
    var $_iconScrollDown = $('.icon-scroll-down');
    var blogSubmenu = $('#blog-submenu');
    var $productSliderNav = $('.product-slider-nav');
    var $responsiveBackgrounds = $('.responsive-background');

    initCookies();


    $('body').addClass('ready');
    $('#loading-overlay').addClass('-hide');
    setTimeout(function() {
        $('#loading-overlay').remove();
    }, 300);


    if ($('#contact-form').length) {
        var href = window.location.href;

        if (href && href.indexOf('form') != -1) {
            $('html, body').animate({
                scrollTop: $('#contact-form').offset().top - 60
            }, 300);
        }
    }

    var setResponsiveBackgrounds = function() {
        var width = $(window).innerWidth();
        var attr = parseInt(width, 10) < 768 ? 'data-attr-md' : 'data-attr-lg';
        $.each($responsiveBackgrounds, function(index, item) {
            var url = $(item).attr(attr);
            $(item).css('background-image', 'url(' + url + ')');
        });
    }
    $(window).on('resize', setResponsiveBackgrounds);
    setResponsiveBackgrounds();

    $('#navigation .menu-item-has-children > a').click(function(e) {
        e.preventDefault();
        var $_parent = $(this).parents('.menu-item-has-children');
        $_parent.toggleClass('-active');
        $_parent.find('ul').slideToggle(300);
    });

    $(document).scroll(function(e) {
        if ($_iconScrollDown) {
            if ($(e.target).scrollTop() > 0 && $_iconScrollDown.hasClass('shake')) {
                $_iconScrollDown.removeClass('shake');
            }
        }

        if ($(e.target).scrollTop() > 0 && !$_header.hasClass('-small')) {
            $_header.addClass('-small');
        } else if ($(e.target).scrollTop() === 0 && $_header.hasClass('-small')) {
            $_header.removeClass('-small');
        }
    });

    $('#hamburger').click(function(e) {
        e.preventDefault();
        $('body').toggleClass('hamburger-active');
    });

    if ($('#breadcrumb-select')) {
        $('#breadcrumb-select').prop('selectedIndex', 0);
        $('#breadcrumb-select').change(function(e) {
            if (e.target.value) {
                window.location = e.target.value;
            }
        });
    }
    $('#overlay').click(function(e) {
        e.preventDefault();
        $('body').removeClass('hamburger-active');
        $('body').removeClass('modal-active');
        $('#product-price-modal.-active').removeClass('-active').fadeOut(300);
    });

    $('.main-slider').slick({
        dots: true,
        infinite: true,
        fade: true,
        speed: 300,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000
    });

    if ($('.pricing .pricing-carousel-item').length) {

        var pricingSettings = {
            dots: false,
            infinite: true,
            speed: 300,
            arrows: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
        };

        var $pricingSlider = $('.pricing .pricing-carousel');
        $pricingSlider.slick(pricingSettings);

        // $(window).on('resize', function() {
        //     if ($(window).width() < 768) {
        //         if ($pricingSlider.hasClass('slick-initialized')) {
        //             $pricingSlider.slick('unslick');
        //         }
        //         return
        //     }

        //     if (!$pricingSlider.hasClass('slick-initialized')) {
        //         return $pricingSlider.slick(settings);
        //     }
        // });
    }

    if ($('.recomended-list li').length > 1) {
        $('.recomended-list').slick({
            dots: false,
            infinite: true,
            speed: 300,
            arrows: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }
    if ($('.partners-list li').length > 1) {
        $('.partners-list').slick({
            dots: false,
            infinite: true,
            speed: 300,
            arrows: true,
            slidesToShow: 8,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 1500,
            responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    if ($('.intro-slider li').length > 1) {
        $('.intro-slider').slick({
            dots: false,
            infinite: true,
            fade: true,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false
        });
    }

    $('.submenu-toggle').click(function(e) {
        e.preventDefault();
        $(this).parents('.submenu-container').toggleClass('-active');
    })

    if (blogSubmenu.length) {
        var sectionTiles = $('.section-tiles');

        blogSubmenu.affix({
            offset: {
                top: $('[data-affix-start]').offset().top,
                bottom: $(document).outerHeight(true) - $('[data-affix-end]').offset().top
            }
        });
        blogSubmenu.find('#blog-submenu-trigger').click(function(e) {
            e.preventDefault();
            blogSubmenu.toggleClass('-active');
            $('html, body').stop().animate({ scrollTop: blogSubmenu.offset().top }, 300);
        });

        blogSubmenu.find('.blog-submenu-dd-trigger').click(function(e) {
            e.preventDefault();
            var $_parent = $(this).parents('.blog-submenu-item');
            $_parent.toggleClass('-active');
            $_parent.find('.blog-submenu-lvl-2').slideToggle(300);
        });
    }

    if ($productSliderNav.length) {
        $('.product-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.product-slider-nav'
        });

        $productSliderNav.slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            asNavFor: '.product-slider',
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
    }

    var $_pricings = $('.pricing');
    if ($_pricings.length) {
        $.each($_pricings, function(i, item) {
            if (i == 0) {
                $(item).find('.pricing-cont').addClass('is-active');
            } else {
                $(item).find('.pricing-cont').addClass('is-closed');
            }
        });
        $('.pricing .pricing-close-btn').click(function(e) {
            e.preventDefault();
            var $_currentPricingCont = $(this).closest('.pricing').find('.pricing-cont');
            $_currentPricingCont.removeClass('is-active');
            $_currentPricingCont.addClass('is-closed');
        });
        setTimeout(function() {
            var $currentActive = $('.pricing .pricing-cont.is-active');
            if($currentActive){
                $currentActive.removeClass('is-active');
                $currentActive.addClass('is-closed');
            }
        }, 3000);
    }

    $('#btn-add-comment').click(function(e) {
        e.preventDefault();
        $('#add-comment-form').slideToggle();
    });

    $('#btn-show-price').click(function(e) {
        e.preventDefault();
        $(this).closest('.pricing-cont').removeClass('is-active');
        $(this).closest('.pricing-cont').addClass('is-closed');
        $('#product-price-modal').addClass('-active').fadeIn(300);
        $('body').addClass('modal-active');
    });

    $('.btn-close-modal').click(function(e) {
        e.preventDefault();
        $('#product-price-modal').removeClass('-active').fadeOut(300);
        $('body').removeClass('modal-active');
    });

    if ($('[tab-toggle-id]').length) {
        $('[tab-toggle-id]').click(function(e) {
            e.preventDefault();
            var id = $(this).attr('tab-toggle-id');
            var $currentActiveTabPanel = $('[tab-id].-active');
            var $tabPanel = $('[tab-id="' + id + '"]');
            $('[tab-toggle-id].-active').removeClass('-active');
            $currentActiveTabPanel.hide();
            $currentActiveTabPanel.removeClass('-active');
            $(this).addClass('-active');
            $tabPanel.show();
            $tabPanel.addClass('-active');
        });
    }

    if ($('.download-select').length) {
        $('.download-select').customSelect();
        $('.download-select').change(function(e) {
            var $_subcategory = $(this).closest('.download-subcategory-cont');
            var $_currentActive = $_subcategory.find('.download-subcategory.-active');
            var currentActiveID = $_currentActive.attr('subcategory-id');
            if (e.target.value !== currentActiveID) {
                $_currentActive.removeClass('-active');
                $_subcategory.find('[subcategory-id="' + e.target.value + '"]').addClass('-active');
            }

        });
    }
});


function initCookies() {
    var key = 'krakmetal_info';
    if (!getCookie(key)) {
        var $cookieCont = $('#cookies-container');
        $cookieCont.addClass('active');
        $cookieCont.find('.btn').on('click', function(e) {
            e.preventDefault();
            $cookieCont.removeClass('active');
            setCookie(key, 'value', 30);
        });
    }
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}